module.exports = __webpack_public_path__ + "static/media/tracker-yesno.7e046337.svg";